module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p3"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i', [_vm._v("The author wishes to thank … ")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i', [_vm._v("Mark Ziesing for his patience and supportiveness")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i', [_vm._v("Nancy Collins for her Sympathy for the Devil")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i', [_vm._v("Micky Perry again for her editorial help")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i', [_vm._v("Julian for restoring some of my innocence")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-239d4be0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section3.vue
// module id = 72
// module chunks = 0